import React, { useState } from "react";
import { ArrowLeft, ExternalLink, RotateCw, TriangleAlert } from "lucide-react";
import { getIcon } from "@/lib/iconMap";

export const WebView = ({ app, onBack }) => {
  const [key, setKey] = useState(0);
  const Icon = getIcon(app.icon);

  return (
    <div className="flex h-screen flex-col" data-testid="webview-panel">
      <div className="flex h-16 shrink-0 items-center gap-3 border-b border-border bg-background/90 px-4 backdrop-blur-md">
        <button onClick={onBack} data-testid="webview-back"
          className="flex items-center gap-2 rounded-full border border-border bg-card px-3 py-2 text-sm font-medium transition-colors hover:bg-accent">
          <ArrowLeft className="h-4 w-4" /> Back
        </button>

        <div className={`${app.color} flex h-8 w-8 items-center justify-center rounded-lg text-white`}>
          <Icon className="h-4 w-4" />
        </div>
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold leading-none">{app.name}</p>
          <p className="truncate text-xs text-muted-foreground">{app.url}</p>
        </div>

        <div className="ml-auto flex items-center gap-2">
          <button onClick={() => setKey((k) => k + 1)} data-testid="webview-reload"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-border bg-card text-muted-foreground transition-colors hover:text-foreground"
            aria-label="Reload">
            <RotateCw className="h-4 w-4" />
          </button>
          <a href={app.url} target="_blank" rel="noopener noreferrer" data-testid="webview-open-external"
            className="flex items-center gap-2 rounded-full border border-border bg-card px-3 py-2 text-sm font-medium transition-colors hover:bg-accent">
            <ExternalLink className="h-4 w-4" /> Open in browser
          </a>
        </div>
      </div>

      <div className="relative flex-1 bg-muted/30">
        <iframe
          key={key}
          src={app.url}
          title={app.name}
          data-testid="webview-iframe"
          className="h-full w-full border-0"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-modals allow-downloads"
        />
        <div className="pointer-events-none absolute bottom-4 left-1/2 flex -translate-x-1/2 items-center gap-2 rounded-full border border-border bg-card/90 px-4 py-2 text-xs text-muted-foreground shadow-lg backdrop-blur">
          <TriangleAlert className="h-3.5 w-3.5" />
          Some sites block embedding — use "Open in browser" if it stays blank.
        </div>
      </div>
    </div>
  );
};
